import { FieldReview } from '../types';

const FIELD_REVIEWS_KEY = 'halisaha_field_reviews';

function readReviews(): FieldReview[] {
  try {
    const raw = localStorage.getItem(FIELD_REVIEWS_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as FieldReview[];
  } catch {
    return [];
  }
}

function writeReviews(list: FieldReview[]) {
  localStorage.setItem(FIELD_REVIEWS_KEY, JSON.stringify(list));
}

export function getReviewsByField(fieldId: string): FieldReview[] {
  return readReviews()
    .filter((item) => item.fieldId === fieldId)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}

export function upsertFieldReview(input: {
  fieldId: string;
  customerId: string;
  customerName: string;
  rating: number;
  comment: string;
}): { ok: true; review: FieldReview } | { ok: false; error: string } {
  const rating = Number(input.rating);
  if (!Number.isFinite(rating) || rating < 1 || rating > 5) {
    return { ok: false, error: 'Puan 1 ile 5 arasında olmalıdır.' };
  }

  const comment = input.comment.trim();
  if (comment.length < 3) {
    return { ok: false, error: 'Yorum en az 3 karakter olmalıdır.' };
  }

  const list = readReviews();
  const existingIndex = list.findIndex(
    (item) => item.fieldId === input.fieldId && item.customerId === input.customerId
  );

  const next: FieldReview = {
    id:
      existingIndex >= 0
        ? list[existingIndex].id
        : `rev-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    fieldId: input.fieldId,
    customerId: input.customerId,
    customerName: input.customerName.trim() || 'Kullanici',
    rating,
    comment,
    createdAt: new Date().toISOString(),
  };

  if (existingIndex >= 0) {
    list[existingIndex] = next;
  } else {
    list.unshift(next);
  }
  writeReviews(list);
  return { ok: true, review: next };
}

export function getFieldRatingSummary(
  fieldId: string,
  baseRating: number,
  baseReviewCount: number
): { rating: number; reviewCount: number } {
  const list = getReviewsByField(fieldId);
  if (list.length === 0) {
    return {
      rating: Number(baseRating.toFixed(1)),
      reviewCount: baseReviewCount,
    };
  }

  const total = baseRating * baseReviewCount + list.reduce((sum, item) => sum + item.rating, 0);
  const reviewCount = baseReviewCount + list.length;
  return {
    rating: Number((total / reviewCount).toFixed(1)),
    reviewCount,
  };
}
